// extracted by mini-css-extract-plugin
export default {"container":"CB-z","dimension":"DB-z","dimensionLabels":"EB-z"};